<template>
  <div id="loyout" class="nationwide padding-sm">
    <div class="flex flex-direction justify-center">
      <header>
        <!-- 页面头部 -->
        <div class="all-title flex justify-center align-center">
          <div class="img-bg">
            <div class="flex justify-center align-center" style="height:55px;">
              <div class="flex justify-end align-center text-xsss  flex1" @click="showNationDialogFunc()">
                <!-- 徐州<img class="clickNationwideModal" src="@/assets/images/index/click.png"/> -->
              </div>
              <div class="flex align-center justify-center text-xs flex1" style="margin:0 45px">
                运营监控调度可视化大屏
              </div>
              <div class="flex justify-start align-center text-xsss flex1">
                {{ nowDate + ' ' + nowWeek + ' ' + nowTime }}
              </div>
            </div>
          </div>
        </div>
      </header>
      <div id="elmain">
        <!-- 页面主体路由 -->
        <transition name="main" mode="out-in">
          <router-view :key="$route.fullPath"></router-view>
        </transition>
      </div>
      <footer>
        <!-- 页面底部 -->
        <!-- <footerTab></footerTab> -->
      </footer>
    </div>
    <div class="nationDialog" v-show="showNationDialog">
      <div class="dialog flex flex-direction">
        <div class="diaTop flex justify-between align-center pointer" @click="jumpToNationwide">
          <div class="title">全国</div>
          <div class="close pointer" @click="showNationDialog=false;"><img src="@/assets/images/index/close.png"/></div>
        </div>
        <div class="diaCener">
          <div class="province">
            <div class="title">省份</div>
            <div class="provItem">
              <p class="text" :class="{'select':curProvince==index}" v-for="(item,index) in provinceStationInfo" :key="index" @click="clickProvince(item,index)">{{item.provinceName | formatterProvince}}</p>
            </div>
          </div>
          <div class="province" v-show="showCity&&cityStationInfo.length>0">
            <div class="title">城市</div>
            <div class="provItem">
              <p class="text" :class="{'select':curCity==index}" v-for="(item,index) in cityStationInfo" :key="index" @click="clickCity(item,index)">{{item.cityName}}</p>
            </div>
          </div>
          <div class="province" v-show="showDistrict&&districtStationInfo.length>0">
            <div class="title">区域</div>
            <div class="provItem">
              <p class="text" :class="{'select':curDistrict==index}" v-for="(item,index) in districtStationInfo" :key="index" @click="clickDistrict(item,index)">{{item.districtName}}</p>
            </div>
          </div>
        </div>

        <div class="diaBottom flex">
          <button class="confirm pointer" @click="confirm">确定</button>
        </div>
      </div>
    </div>
    <!-- <div class="threeDChange flex">
      <img v-show ="showFullScreen" src="@/assets/images/index/fullscreen.png" @click="clicMapChange">
      <img  v-show ="!showFullScreen" src="@/assets/images/index/fullscreen-exit.png" @click="clicMapChange">
    </div> -->
    <div class="fullScreen flex">
      <img v-show ="showFullScreen" src="@/assets/images/index/fullscreen.png" @click="clickFullScreen">
      <img  v-show ="!showFullScreen" src="@/assets/images/index/fullscreen-exit.png" @click="clickExit">
    </div>
  </div>
</template>

<script>
function isFullScreen() {
  if (document.fullscreen) {
      return true;
    } else if (document.mozFullScreen) {
        return true;
    } else if (document.webkitIsFullScreen) {
        return true;
    } else if (document.msFullscreenElement) {
        return true;
    } else if (window.fullScreen) {
        return true;
    } 
    return false;
}

import { formatter } from '@/utils/index.js'
import { indexCenter } from '@/api/indexCenter';
//底部tab  站点、电池、车辆
import footerTab from '@/components/footer';

export default {
  data () {
    return {
      nowDate: "",    // 当前日期
			nowTime: "",    // 当前时间
			nowWeek: "",    // 当前星期
      provinceStationInfo:[],//全国站点
      curProvince:-1,//当前站点
      curDistrict:-1,//当前大区
      curCity:-1,//当前城市
      showCity:false,//是否显示城市
      showDistrict:false,//是否显示大区
      cityStationInfo:[],//省级站点
      districtStationInfo:[],//市级站点
      curDistrictInfo:{district:"110101"},//当前大区信息
      showNationDialog:false,//显示全国弹框
      showFullScreen:true,//全屏按钮
      adcode:'',
    };
  },
  components: {
    footerTab
  },
  methods: {
    clicMapChange(){
      console.log("mapChange",this.$refs)
    },
    //全屏
    clickFullScreen(){
      const docElm = document.documentElement
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen()
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      }
      this.showFullScreen = !this.showFullScreen;
    },
    //点击退出全屏
    clickExit(){
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
      this.showFullScreen = !this.showFullScreen;
    },
    //清空数据
    clearData(){
      this.districtStationInfo.length=0;
      this.cityStationInfo.length=0;
      this.curProvince=-1;
      this.curDistrict=-1;
      this.curCity=-1;
    },
    showNationDialogFunc(){
      this.selectCountryStationInfo();
      this.showNationDialog=true;
    },
    //跳转到全国
    jumpToNationwide(){
      this.showNationDialog=false;//关闭弹框
      this.$router.push({
          path: '/pcnationwideSite',
          query: {}
      })
    },
    //点击省级 区分 直辖市和其他
    clickProvince(item,index){
      this.clearData();
      let adcode = parseInt(item.province);
      this.adcode = adcode;
      let updateParams = {};
      if(this.curProvince==index){
        return;
      }
      this.curProvince = index;
      if([110000,120000, 500000,310000].includes(adcode)){
        updateParams = {
          city:adcode.toString().substring(0,2)+'0100'
        }
        this.selectCityStationInfo(updateParams)            
      } else {
        updateParams = {
          province:adcode
        }
        this.selectProvinceStationInfo(updateParams);
      }
    },
    clickCity(item,index){
      if(this.curCity!=index){
        this.curCity = index;
        this.adcode = item.city;
        this.selectCityStationInfo({'city':item.city})
      }
    },
    clickDistrict(item,index){
      if(this.curDistrict!=index){
        this.curDistrict = index;
        this.curDistrictInfo = item;
      }
    },
    //确定按钮
    confirm(){
      if(this.curProvince==-1&&this.curCity==-1&&this.curDistrict==-1){
        console.log("您还没有选择省份");

        return;
      }

      if(this.curProvince>-1&&this.curCity==-1&&this.curDistrict==-1){
        console.log("选择省份");
        this.showNationDialog=false;//关闭弹框
        this.$router.push({
            path: '/pcnationwideSite',
            query: {
              province:this.adcode
            }
        })

        return;
      }

      if(this.curProvince>-1&&this.curCity>-1&&this.curDistrict==-1){
        console.log("选择城市");
        this.showNationDialog=false;//关闭弹框
        this.$router.push({
            path: '/pcnationwideSite',
            query: {
              city:this.adcode
            }
        })
        return;
      }

      if(this.curProvince>-1&&this.curCity>-1&&this.curDistrict>-1){
        console.log("选择城市");
        this.showNationDialog=false;//关闭弹框
        this.$router.push({
            path: '/pcdistrict',
            query: {
              adcode:this.curDistrictInfo.district
            }
        })
        return;
      }

      // if(window.location.href.indexOf('district')>-1){
      //   //TODO:暂时方案，刷新页面
      //   this.$router.go(0);
      // }
    },
    //获取全国站点数据
    selectCountryStationInfo(){
        let _this = this;
        indexCenter
        .selectCountryStationInfo()
        .then((res) => {
          if(!res) return;
          this.provinceStationInfo = res;
        })
        .catch((err) => {
        });
    },
    //获取省级站点数据
      selectProvinceStationInfo(updateParams){
        let _this = this;
        //获取省的站点信息
        indexCenter
        .selectProvinceStationInfo(updateParams)
        .then((res) => {
          if(!res) return;
          this.cityStationInfo = res;
          if(res.length>0){
            this.showCity = true;
            this.showDistrict = false;
          }else{
            this.showCity = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      },
      //获取区级站点数据
      selectCityStationInfo(updateParams,adcode,type){
        let _this = this;
        //获取省的站点信息
        indexCenter
        .selectCityStationInfo(updateParams)
        .then((res) => {
          if(!res) return;
          this.districtStationInfo = res;
          if(res.length>0){
            this.showDistrict = true;
          }else{
            this.showDistrict = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      },
    currentTime() {
        setInterval(this.getDate, 60);
    },
    getDate: function() {
        var _this = this;
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth() + 1;
        let dd = new Date().getDate();
        let week = new Date().getDay();
        let hh = new Date().getHours();
        let mf =
            new Date().getMinutes() < 10
                ? "0" + new Date().getMinutes()
                : new Date().getMinutes();
        if (week == 1) {
            this.nowWeek = "星期一";
        } else if (week == 2) {
            this.nowWeek = "星期二";
        } else if (week == 3) {
            this.nowWeek = "星期三";
        } else if (week == 4) {
            this.nowWeek = "星期四";
        } else if (week == 5) {
            this.nowWeek = "星期五";
        } else if (week == 6) {
            this.nowWeek = "星期六";
        } else {
            this.nowWeek = "星期日";
        }
        _this.nowTime = hh + ":" + mf;
        _this.nowDate = yy + "年" + mm + "月" + dd +"日";
    }
	},
  filters: {
    formatterProvince(name){
      if(!name) return '';
      console.log(name)
      return formatter(name)
    },
  },
	mounted() {
		this.currentTime();
	},
	// 销毁定时器
	beforeDestroy: function() {
		if (this.getDate) {
      clearInterval(this.getDate); // 在Vue实例销毁前，清除时间定时器
		}
	}
};
</script>

<style lang="scss">
@import '@/assets/scss/pc.scss';
.nationwide{
  padding-top: 0px;
  // width: 7000px;
}
.all-title{
  width: 100%;
  height: 110px;
  .img-bg{
    width: 1280px;
    height: 55px;
    background: url('~@/assets/images/index/titel_png.png') no-repeat center center;
    background-size: 1280px 55px;
    .leftBox{
      width: 300px;
      margin-right: 180px;
    }
    .bigtitle{
      line-height: 110px;
      font-family: 'PuHuiTi Heavy';
    }
    .rightBox{
      width: 300px;
      margin-left: 180px;
    }
  }
}
.clickNationwideModal{
  width:20px;
  height:18px;
  margin-left:10px;
}
// 全国省市区-弹框
.nationDialog{
  width:900px;
  height:680px;
  position: fixed;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  z-index:99;
  
  .title{
    font-size:24px;
  }
  .text{
    font-size:20px;
    &.select{
      background: rgba(42,255,251,0.23);
      border: 1px solid #2AFFFB;
      border-radius: 30px;
    }
  }
  .close{
    width:30px;
    height:30px;
    img{
      width:100%;
      height:100%;
    }
  }
  .dialog{
    height:100%;
    padding:45px 30px 30px 80px;
    background: linear-gradient(180deg, rgba(35, 94, 92,.8) 0%, rgba(36, 98, 96,.8) 100%);
    .diaTop{
      height:42px;
      margin-bottom:46px;
    }
    .diaCener{
      flex:1;
      overflow-y: scroll;
      .province{
        margin-bottom:30px;
      }
      .provItem{
        display: grid;
        grid-template-columns: repeat(5, 20%);
        grid-row-gap: 16px;
        text-align: center;
      }
    }
    .diaBottom{
      
      button{
        width:98px;
        height:40px;
        border-radius: 8px;
        margin-left:auto;
        font-size:18px;
        font-weight: bold;
        background: linear-gradient(180deg, rgba(10, 98, 96,.6) 0%, rgba(1, 177, 169, 0.6) 100%);
        border-radius: 8px;
      }
    }
  }
  
}
.fullScreen{
  position:fixed;
  top:30px;
  right:30px;
  img{
    width:20px;
    height:20px;
    margin-right:15px;
  }
}
.threeDChange{
  position:absolute;
  top:30px;
  right:70px;
  img{
    width:20px;
    height:20px;
    margin-right:15px;
  }
}
</style>